<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChangeTime"
          >
          </el-date-picker>

          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="GetFoodDayPeopleConsumeInfo"
            >查询</el-button
          >
          <el-button
            v-if="!isData"
            type="goon"
            style="margin-left: 20px"
            @click="ExportGetFoodDayPeopleConsumeInfo"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <template v-if="!isData">
      <div
        class="tui-tableTitle"
        style="font-size: 30px; font-weight: bold; text-align: center"
      >
        本月各种食物每人每日消耗量
      </div>
      <el-card>
        <div class="tui-allNum">总人日数：{{ dataInfo.TotalPeopleNum }}</div>
        <!-- 表格 -->
        <table>
          <tr>
            <th class="bg">食品类别</th>
            <th
              class="bg"
              v-for="(item, index) in dataInfo.FoodDayConInfo"
              :key="index"
            >
              {{ item.Name }}
            </th>
            <!-- <th class="bg">总人日数：</th> -->
          </tr>

          <tr>
            <td rowspan="2">食物重量（克）</td>
            <td v-for="(item, index) in dataInfo.FoodDayConInfo" :key="index">
              {{ item.Value }}
            </td>
            <!-- <td rowspan="2">{{ dataInfo.TotalPeopleNum }}</td> -->
          </tr>
          <tr>
            <td v-for="(item, index) in dataInfo.FoodDayConInfo" :key="index">
              {{ item.ValueTwo }}
            </td>
            <!-- <td></td> -->
          </tr>
        </table>
        <div class="tui-tableTitle"></div>
        <table cellspacing="0">
          <tr>
            <th class="bg"></th>
            <th class="bg" colspan="6">热量食物来源分布</th>
            <th class="bg" colspan="3">热量营养素来源分布</th>
            <th class="bg" colspan="4">蛋白质来源分布</th>
          </tr>
          <tr>
            <th class="bg"></th>
            <th
              class="bg"
              v-for="(item, index) in dataInfo.FoodDayTwoConInfo"
              :key="index"
            >
              {{ item.Name }}
            </th>
          </tr>

          <tbody>
            <tr>
              <td>摄入量（克）</td>
              <td
                v-for="(item, index) in dataInfo.FoodDayTwoConInfo"
                :key="index"
              >
                {{ item.Value }}
              </td>
            </tr>
            <tr>
              <td>占总摄入量（%）</td>
              <td
                v-for="(item, index) in dataInfo.FoodDayTwoConInfo"
                :key="index"
              >
                {{ item.ValueTwo }}%
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tui-tableTitle"></div>
        <table cellspacing="0">
          <tr>
            <th class="bg"></th>
            <th class="bg" colspan="6">食物产生热量来源分布</th>
          </tr>
          <tr>
            <th class="bg"></th>
            <th
              class="bg"
              v-for="(item, index) in dataInfo.FoodDayThreeConInfo"
              :key="index"
            >
              {{ item.Name }}
            </th>
          </tr>

          <tbody>
            <tr>
              <td>各类食物产生的热量</td>
              <td
                v-for="(item, index) in dataInfo.FoodDayThreeConInfo"
                :key="index"
              >
                {{ item.Value }}
              </td>
            </tr>
            <tr>
              <td>占总热量（%）</td>
              <td
                v-for="(item, index) in dataInfo.FoodDayThreeConInfo"
                :key="index"
              >
                {{ item.ValueTwo }}%
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tui-tableTitle"></div>
        <table>
          <tr>
            <th style="background: rgb(242, 245, 255)"></th>
            <th style="background: rgb(242, 245, 255)">蛋白质（克）</th>
            <th style="background: rgb(242, 245, 255)">脂肪</th>
            <th style="background: rgb(242, 245, 255)">碳水化合物（克）</th>
          </tr>
          <tr
            v-for="(item, index) in dataInfo.threeNutritionDetails"
            :key="index"
          >
            <td>{{ item.TypeName }}</td>
            <td>{{ item.Protein }}</td>
            <td>{{ item.Fat }}</td>
            <td>{{ item.Carbohydrate }}</td>
          </tr>
        </table>
      </el-card>
    </template>
    <el-card v-if="isData">
      <el-empty description="暂无数据"></el-empty>
    </el-card>
    <div class="tui-tableTitle"></div>
  </div>
</template>
<script>
import {
  GetFoodDayPeopleConsumeInfo,
  ExportGetFoodDayPeopleConsumeInfo,
} from "../../../api/api";

export default {
  data() {
    return {
      starttime: [],
      dataInfo: {},
      isData: false,
    };
  },
  async created() {
    let Time = localStorage.getItem("Time");
    console.log(Time);
    if (Time) {
      this.starttime = JSON.parse(localStorage.getItem("Time"));
    } else {
      await this.getNowTime();
    }

    await this.GetFoodDayPeopleConsumeInfo();
  },
  methods: {
    async ExportGetFoodDayPeopleConsumeInfo() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await ExportGetFoodDayPeopleConsumeInfo({
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      });
      if (res.data.success) {
        loading.close();
        window.open(res.data.response);
      }
    },
    async GetFoodDayPeopleConsumeInfo() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await GetFoodDayPeopleConsumeInfo({
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      });
      loading.close();
      if (res.data.success) {
        this.isData = false;

        this.dataInfo = res.data.response;
      } else {
        this.isData = true;
      }
    },
    onChangeTime(e) {
      localStorage.setItem("Time", JSON.stringify(e));
    },
    async getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var day = now.getDate(); //得到天
      if (day < 10) {
        day = "0" + day;
      }
      month = month + 1;
      month = month.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}`;
      console.log(`${year}-${month}-01`);
      this.starttime.push(`${year}-${month}-01`);
      this.starttime.push(`${year}-${month}-${day}`);
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  background: rgb(242, 245, 255) !important;
}
.tui-allNum {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.25rem 0;
  font-size: 0.225rem;
  font-weight: 600;
}
table {
  width: 100%;
  // min-width: 600px;
  border-collapse: collapse;
}

table caption {
  font-size: 2em;

  font-weight: bold;

  margin: 1em 0;
}

th,
td {
  border: 1px solid #ebeef5;

  text-align: center;

  padding: 20px 0;
}

table thead tr {
  background-color: #ebeef5;
}

table tfoot tr td {
  text-align: right;

  padding-right: 20px;
}

.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.tui-box {
  width: 382px;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}

.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>